import { ResourceClient } from "@tento-core/resource-client";

// App resource facade:
// - current: bundled app assets served from this origin, e.g. /@/static/weather/locations.json
// - root: content pages on the root domain, e.g. /docs/content/...
// - static: assets owned by static.lona.so, e.g. sticker registries/textures
export const LonaResources = {
  current: ResourceClient.currentOrigin(),
  root: ResourceClient.forDomain("root"),
  static: ResourceClient.forDomain("static"),
};
